import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { useAuthStore, useTenantStore } from '@/stores'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Checkbox } from '@/components/ui/checkbox'
import LogoUrl from '@/assets/hogeadmin.logo.color.svg'

const Login = observer(() => {
  const authStore = useAuthStore()
  const tenantStore = useTenantStore()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [keepSession, setKeepSession] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')

    if (email === '' || password === '') {
      return
    }

    const success = await authStore.login(email, password, keepSession)
    if (success && authStore.currentTenantId) {
      // ログイン成功後、所属テナント情報を取得
      await tenantStore.getTenant(authStore.currentTenantId)
      navigate('/')
    } else if (!success) {
      setError(authStore.error || 'ログインに失敗しました')
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/50">
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-4">
          <img src={LogoUrl} alt="hogeAdmin" className="mx-auto h-12 w-auto" />
          <CardTitle className="text-center text-2xl">ログイン</CardTitle>
          <CardDescription className="text-center">
            アカウント情報を入力してください
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">メールアドレス</Label>
              <Input
                id="email"
                type="text"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value)
                  setError('')
                }}
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">パスワード</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value)
                  setError('')
                }}
                required
              />
            </div>
            <div className="flex items-center space-x-2">
              <Checkbox
                id="keep-session"
                checked={keepSession}
                onCheckedChange={(checked) => setKeepSession(checked === true)}
              />
              <Label htmlFor="keep-session" className="cursor-pointer">
                ログイン状態を保持する
              </Label>
            </div>
            <Button
              type="submit"
              className="w-full"
              disabled={authStore.isLoading}
            >
              {authStore.isLoading ? 'ログイン中...' : 'ログイン'}
            </Button>
            {error && (
              <p className="text-sm text-destructive text-center">
                {error}
              </p>
            )}
          </form>
        </CardContent>
      </Card>
    </div>
  )
})

export default Login